import { useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import useDateUtility from "../utilities/useDateUtility";
import useRuleUtility from "../utilities/useRuleUtility";
import useRateUtility from "../utilities/useRateUtility";
import useWindowUtility from "../utilities/useWindowUtility";

export default function Table({ formUtility, mappings, data, filter, selectedIndex, pageSize, onClick, onDoubleClick, onClickAdd, onRemove }) {

    const dateUtility = useDateUtility();
    const ruleUtility = useRuleUtility();
    const rateUtility = useRateUtility();
    const windowUtility = useWindowUtility();

    const [pageNumber, setPageNumber] = useState(1);

    let xData = data?.map((d, i) => ({...d, key: i})) ?? [];

    var numberOfPages = !pageSize || pageSize < 1 || xData.length <= pageSize
        ? 1
        : Math.ceil(xData.length / pageSize);

    var tableData = pageSize && pageSize >= 1
        ? xData.filter((d) => filter? filter(d) : true).slice(pageNumber * pageSize - pageSize, pageNumber * pageSize)
        : xData.filter((d) => filter ? filter(d) : true);

    function formatValue(dataType, value) {
        //TODO: fix format for display
        switch (dataType) {
            case "date":
                return dateUtility.toDateString(value);
            case "datetime":
                return dateUtility.toDateTimeString(value);
            case "time":
                return value?.toString()?.trim() ?? "";
            case "dayOfWeek":
                return dateUtility.getDayOfWeek(value)?.name;
            case "ruleType":
                return ruleUtility.getRuleType(value)?.name;
            case "condition":
                return ruleUtility.getCondition(value)?.name;
            case "rateType":
                return rateUtility.getRateType(value)?.name;
            case "rateMode":
                return rateUtility.getRateMode(value)?.name;
            case "groupType":
                return windowUtility.getGroupType(value)?.name;
            default:
                return value?.toString()?.trim() ?? "";
        }
    }
    
    function handlePageNumberClicked(n) {
        if (formUtility?.fieldsDisabled)
            return;

        var newPageNumber
            = n < 1 ? 1
            : n > numberOfPages ? numberOfPages
            : n;

        if (newPageNumber === pageNumber)
            return;

        setPageNumber(newPageNumber);
    }

    function handleOnClick(event, item) {
        event.stopPropagation();

        if (!onClick || formUtility?.fieldsDisabled)
            return;

        onClick(item.key);
    }

    function handleOnDoubleClick(event, item) {
        event.stopPropagation();

        if (!onDoubleClick || formUtility?.fieldsDisabled)
            return;

        onDoubleClick(item.key);
    }

    function handleOnRemove(event, item) {
        event.stopPropagation();

        if (!onRemove || formUtility?.fieldsDisabled)
            return;

        onRemove(item.key);
    }

    function handleOnClickAdd(event) {
        if (!onClickAdd || formUtility?.fieldsDisabled)
            return;

        onClickAdd();
    }
    
    return (
        <>
            <table striped className="table table-striped table-raised">
                <thead>
                    <tr>
                        {mappings.map(m => <th>{m.header}</th>)}
                        {
                            onClickAdd || onRemove
                                ?
                                <th className="table-row-buttons">
                                    {onClickAdd? <i onClick={handleOnClickAdd} className="fas fa-plus-circle"></i> : null}
                                </th>
                                : null
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        tableData.map((d) =>
                            <tr key={d.key} className={selectedIndex === d.key? "active" : ""} onClick={(e) => handleOnClick(e, d)} onDoubleClick={(e) => handleOnDoubleClick(e, d)}>
                                {mappings.map(x => <td>{formatValue(x.dataType, d[x.field])}</td>)}
                                {
                                    onClickAdd || onRemove
                                        ?
                                        <td className="table-row-buttons">
                                            {onRemove ? <i className="fas fa-trash" onClick={(e) => handleOnRemove(e, d)} ></i> : null}
                                        </td>
                                        : null
                                }
                            </tr>
                        )
                    }
                </tbody>
            </table>
            {
                pageSize && pageSize >= 1 && numberOfPages > 1
                    ?
                    <div className="pagination-container">
                        <Pagination>
                            <Pagination.First onClick={() => handlePageNumberClicked(1)} />
                            <Pagination.Prev onClick={() => handlePageNumberClicked(pageNumber - 1)} />
                            {numberOfPages > 7 && pageNumber > 4 ? <Pagination.Ellipsis /> : null}
                            {
                                (
                                    numberOfPages <= 7 ? [1, 2, 3, 4, 5, 6, 7]
                                        :pageNumber <= 4 ? [1, 2, 3, 4, 5, 6]
                                        : numberOfPages === pageNumber ? [-5,-4, -3, -2, -1, 0].map(n => n + pageNumber)
                                        : numberOfPages === pageNumber + 1 ? [-4, -3, -2, -1, 0, 1].map(n => n + pageNumber)
                                        : numberOfPages === pageNumber + 2 ? [-3, -2, -1, 0, 1, 2].map(n => n + pageNumber)
                                        : [-2, -1, 0, 1, 2].map(n => n + pageNumber))
                                    .filter(n => n <= numberOfPages)
                                    .map(n => <Pagination.Item key={n} active={n === pageNumber} onClick={() => handlePageNumberClicked(n)}>{n}</Pagination.Item>)
                            }
                            {numberOfPages > 7 && pageNumber + 2 < numberOfPages ? <Pagination.Ellipsis /> : null}
                            <Pagination.Next onClick={() => handlePageNumberClicked(pageNumber + 1)} />
                            <Pagination.Last onClick={() => handlePageNumberClicked(numberOfPages)} />
                        </Pagination>
                    </div>
                    : null
            }
        </>
    );
}